import { usePatientInsurancesQuery } from '@common/cache';
import { useState } from 'react';

type UseInsuranceProps = {
  patient_id: string;
};

export const useInsurance = ({ patient_id }: UseInsuranceProps) => {
  const [isBenefitsModalOpen, setIsBenefitsModalOpen] = useState(false);

  const { data } = usePatientInsurancesQuery({
    patient_id,
  });

  const handleOpenBenefitsModal = () => {
    setIsBenefitsModalOpen(true);
  };

  const handleCloseBenefitsModal = () => {
    setIsBenefitsModalOpen(false);
  };

  return {
    isBenefitsModalOpen,
    handleCloseBenefitsModal,
    handleOpenBenefitsModal,
    patientInsurances: data,
  };
};
